import { correctNode as t } from "./correctFocus.js";
var u = function(r) {
  return r[0] && r.length > 1 ? t(r[0], r) : r[0];
}, f = function(r, c) {
  return r.indexOf(t(c, r));
};
export {
  u as pickFirstFocus,
  f as pickFocusable
};
